export default "__VITE_ASSET__Cf2YiD05__"